import React, { useEffect, useState } from 'react';
import about1 from '../../img/main-about-1.png';
import about2 from '../../img/main-about-2.png';
import about3 from '../../img/main-about-3.png';
import solution from '../../img/solution-feature-img.png';
import solution1 from '../../img/solution-icon-1.png';
import solution2 from '../../img/solution-icon-2.png';
import solution3 from '../../img/solution-icon-3.png';
import solutionbenefit1 from '../../img/solution-benefit-1.png';
import solutionbenefit2 from '../../img/solution-benefit-2.png';
import solutionbenefit3 from '../../img/solution-benefit-3.png';
import solutionbenefit4 from '../../img/solution-benefit-4.png';
import solutionbenefit5 from '../../img/solution-benefit-5.png';
import '../../css/remixicon/remixicon.css'; 
import 'aos/dist/aos.css'; 

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const SolutionInfo = () => {

    return(

        <React.Fragment>
            <section className="about-cert">
                
                <div className="area">
                    <div className="main-title">
                        <h3>솔루션 구성요소</h3>
                        <p>IT 솔루션의 소프트웨어 시스템인 애플리케이션, 시스템과 연결 하는 플랫폼, 하드웨어 중심 시스템인 장비 및 디바이스의 세가지 제품으로 구성 되어 있습니다.</p>
                    </div>
                    <div className="main-cont">
                        <div className="solution-base">
                            <div className="base-item base-1">
                                <h3>애플리케이션</h3>
                                <p>플랫폼상에서 각종 제조 실행을 수행하는 애플리케이션. MES, ERP, PLM, SCM 등의 제품이 있습니다.</p>
                            </div>
                            <div className="base-item base-2">
                                <h3>플랫폼</h3>
                                <p>표준화된 정보를 애플리케이션에 전달하는 미들웨어 수준의 기술들. 빅데이터 분석, 사이버 물리 기술, 클라우드 기술 등의 제품이 있습니다.</p>
                            </div>
                            <div className="base-item base-3">
                                <h3>장비 및 디바이스</h3>
                                <p>장비에 내장되는 지능형 임베디드 소프트웨어 & 하드웨어 기술들. 컨트롤러, 로봇, 센서, PC 등의 하드웨어 제품이 있습니다.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="solution-feature light">
                <div className="area">
                    <div className="main-title">
                            <h3>위즈팩토리 솔루션 특징</h3>
                        <p>각 공정을 모듈화 하여, 한 생산라인에서도 최종 고객사의 취향에 따라 유기적·능동적으로 다양한 맞춤형 제품 생산 가능.<br/>
                            가상공간 등을 통해 실시간으로 현장 및 품질을 관리/제어하며 에너지, 인력 등 자원 활용 면에서 효율을 향상시켜, 생산 원가 하락을 통한 제품 경쟁력 강화</p>
                    </div>
                    <div className="main-cont">
                        <div className="feature-wrap">
                            <div className="feature-item-side">
                                <div className="feature-item">
                                    <img src={about1} alt=""/>
                                    <h3>사물인터넷</h3>
                                    <p>IoT 기술을 통해 기계, 장비. 시스템이 서로 연결되어 실시간 데이터 교환을 통해 생산 과정의 투명성이 증가하고 문제 발생 시 즉각적이 대응이 가능</p>
                                </div>
                                <div className="feature-item">
                                    <img src={about2} alt=""/>
                                    <h3>빅데이터 분석</h3>
                                    <p>생산 과정에서 발생하는 데이터를 분석하고 이를 기반으로 공정을 최적화하여 예측 유지보수 가능 및 제품 품질의 신뢰성 증가</p>
                                </div>
                                <div className="feature-item">
                                    <img src={about3}alt=""/>
                                    <h3>인공지능</h3>
                                    <p>실시간으로 데이터를 처리하고 패턴을 인식하여 예측 분석, 리스크 관리, 사용자 경험 제공 등 다양한 분야에서 의사결정을 지원</p>
                                </div>
                            </div>
                            <div className="feature-img"><img src={solution} alt=""/><div className="feature-img-text">SMART FACTORY</div></div>
                            <div className="feature-item-side">
                                <div className="feature-item">
                                    <img src={solution1} alt=""/>
                                    <h3>클라우드 컴퓨팅</h3>
                                    <p>초기 투자 비용을 크게 절감하고 , 효율적으로 운영할 수 있으며 비즈니스규모의 변화에 대응할 수 있는 유연성을 제공</p>
                                </div>
                                <div className="feature-item">
                                    <img src={solution2} alt=""/>  
                                    <h3>사이버-물리 시스템</h3>
                                    <p>기업이 더 빠르고 유연하게 시장의 변화에 대응하고 맞춤형 제품을 효율적으로 생산할 수 있도록 지원</p>
                                </div>
                                <div className="feature-item">
                                    <img src={solution3} alt=""/>
                                    <h3>로보틱스</h3>
                                    <p>높은 정밀도와 빠른 속도로 작업을 수행함으로써 생산성 대폭 향상 및 위험한 환경에서도 안정적으로 작업을 수행</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="solution-benefit">
                <div className="area">
                    <div className="main-title">
                        <h3>솔루션 주요기능 및 이점</h3>
                    </div>
                    <div className="main-cont">
                        <div className="benefit-row">
                            <div className="benefit-title">
                                <h2>1. 생산관리</h2>
                                <p>상용 센서 또는 설비 자체 데이터를 수집해 실시간(실제) 생산량을 카운트 및 모니터링하며, 시스템(ERP, MES 등)과의 연동을 통해 생산계획과 대조가 가능합니다.</p>
                            </div>
                            <div className="benefit-cont">
                                <div className="benefit-half img left">
                                    <img src={solutionbenefit1} alt=""/>
                                </div>
                                <div className="benefit-half right">
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>1</span></div>
                                        <div className="benefit-info">
                                        <h3>성능 데이터</h3>
                                            <span className="benefit-badge">생산량, 가동률, 생산 속도, 가동 중단 시간 등</span>
                                        <p>설비의 작동 성능과 관련된 데이터로 생산성 분석, 공정 효율성 측정, 성능 최적화 및 가동 중단 시간 최소화를 위해 활용됩니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>2</span></div>
                                        <div className="benefit-info">
                                            <h3>상태 데이터</h3>
                                            <span className="benefit-badge">온도, 압력, 진동, 소음 등의 센서 데이터 등</span>
                                            <p>설비의 현재 상태와 건강을 나타내는 데이터로 설비의 이상 징후 감지, 고장 예측, 예방적 유지보수 계획을 수립하기 위해 사용됩니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>3</span></div>
                                        <div className="benefit-info">
                                            <h3>품질 데이터</h3>
                                            <span className="benefit-badge">치수, 정확도, 불량률, 검사 결과 등</span>
                                            <p>제품의 품질을 검사하고 측정하는 데이터로 제품 품질 관리, 품질 기준의 준수 여부 판단, 품질 개선 활동의 기반으로 활용됩니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>4</span></div>
                                        <div className="benefit-info">
                                        <h3>안전 데이터</h3>
                                            <span className="benefit-badge">위험 감지 센서, 사고 기록, 경고 신호 등</span>
                                        <p>작업장의 안전과 관련된 데이터로 작업장 안전 관리, 사고 예방 및 위험 감소 조치의 기반으로 사용됩니다.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="benefit-row">
                            <div className="benefit-title">
                                <h2>2. 설비관리</h2>
                                <p>생산설비에 IoT 게이트웨이 및 측정센서를 설치해 가동상태를 실시간 모니터링하고 설비 이상 여부 데이터를 기반으로 설비의 상태를 분석, 진단합니다.</p>
                            </div>
                            <div className="benefit-cont">
                                <div className="benefit-half left">
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>1</span></div>
                                        <div className="benefit-info">
                                        <h3>설비성능 관리</h3>
                                        <p>설비의 작동 효율성과 생산성을 최적화하기 위한 관리로, 가동률, 생산 속도, 생산량, 설비 가동 중단 시간 등의 성능 지표를 모니터, 분석하고 생산성을 극대화하고, 비효율적인 공정을 최소화하여 전반적인 제조 공정의 효율성을 개선합니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>2</span></div>
                                        <div className="benefit-info">
                                            <h3>예측 유지보수</h3>
                                            <p>설비의 상태 데이터(온도, 진동, 압력 등)를 실시간으로 모니터링하여, 장비 고장을 예측하고 사전에 유지보수를 계획하여 예기치 않은 설비 고장과 가동 중단을 최소화하고, 설비의 수명을 연장하여 운영 비용을 절감합니다.</p>
                                        </div>
                                    </div>
                                
                                </div>
                                <div className="benefit-half img right">
                                    <img src={solutionbenefit2} alt=""/>
                                </div>
                            </div>
                        </div>
                        
                        <div className="benefit-row">
                            <div className="benefit-title">
                                <h2>3. 품질관리</h2>
                                <p>설비 데이터를 실시간 수집, 저장, 모니터링해 품질 변동의 원인을 시각화 하여 품질에 영향을 주는 원인 파악을 통해 불량요소를 추출 및 대응할 수 있습니다.</p>
                            </div>
                            <div className="benefit-cont">
                                <div className="benefit-half img left">
                                    <img src={solutionbenefit3} alt=""/>
                                </div>
                                <div className="benefit-half right">
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>1</span></div>
                                        <div className="benefit-info">
                                        <h3>품질 데이터 분석</h3>
                                        <p>제조 공정에서 생성된 품질 관련 데이터(치수 정확도, 불량률 등)를 수집하고 분석하여, 품질 문제의 원인을 식별하고 개선 조치를 계획하여 데이터 기반의 분석을 통해 품질 관리 프로세스를 지속적으로 개선하고, 최종 제품의 품질을 보장합니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>2</span></div>
                                        <div className="benefit-info">
                                            <h3>품질 관리 시스템 통합</h3>
                                            <p>품질 관리 절차와 기준을 전사적 자원 계획(ERP), 제조 실행 시스템(MES)과 같은 다른 IT 시스템과 통합하여, 전체 제조 공정에 걸쳐 품질 관리의 시스템을 통해 품질 정보의 접근성과 가시성을 높이고, 전사적인 품질 관리와 연속적인 개선 활동을 지원합니다.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="benefit-row">
                            <div className="benefit-title">
                                <h2>4. 환경관리</h2>
                                <p>작업환경 및 설비, 자재, 제품의 상태에 영향을 주는 유해요소를 모니터링하여 제조 환경의 효율성을 높이고, 자원을 절약하며, 환경 영향을 최소화하는 데 목적을 둡니다.</p>
                            </div>
                            <div className="benefit-cont">
                                <div className="benefit-half left">
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>1</span></div>
                                        <div className="benefit-info">
                                        <h3>안전 관리</h3>
                                        <p>작업장 내 위험 요소를 식별하고, 위험을 최소화하기 위해 사고 예방, 위험 평가, 안전 교육 및 응급 대응 등 실행하여 근로자의 안전을 보장하고, 작업장 내 사고 및 부상을 예방할 수 있습니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>2</span></div>
                                        <div className="benefit-info">
                                            <h3>인적 자원 관리</h3>
                                            <p>교육 및 훈련, 경력 개발 기회 제공, 작업 조건 개선 등 포함하여 근로자의 기술과 역량을 강화하고, 작업 환경에서의 만족도와 생산성을 향상을 할 수 있습니다.</p>
                                        </div>
                                    </div>
                                
                                </div>
                                <div className="benefit-half img right">
                                    <img src={solutionbenefit4} alt=''/>
                                </div>
                            </div>
                        </div>
                        
                        <div className="benefit-row">
                            <div className="benefit-title">
                                <h2>5. 에너지관리</h2>
                                <p>공장 전체 또는 라인, 단위 설비별로 전력소모량을 측정하고 가동률을 분석해 효율적인 에너지 관리가 가능합니다.</p>
                            </div>
                            <div className="benefit-cont">
                                <div className="benefit-half img left">
                                    <img src={solutionbenefit5} alt=''/>
                                </div>
                                <div className="benefit-half right">
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>1</span></div>
                                        <div className="benefit-info">
                                        <h3>에너지 모니터링 및 분석</h3>
                                        <p>작업장 내 위험 요소를 식별하고, 위험을 최소화하기 위해 사고 예방, 위험 평가, 안전 교육 및 응급 대응 등 실행하여 근로자의 안전을 보장하고, 작업장 내 사고 및 부상을 예방할 수 있습니다.</p>
                                        </div>
                                    </div>
                                    <div className="benefit-item">
                                        <div className="benefit-num"><span>2</span></div>
                                        <div className="benefit-info">
                                            <h3>에너지 효율성 최적화</h3>
                                            <p>교육 및 훈련, 경력 개발 기회 제공, 작업 조건 개선 등 포함하여 근로자의 기술과 역량을 강화하고 , 작업 환경에서의 만족도와 생산성을 향상을 할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default SolutionInfo;